<template>
  <v-expand-transition>
    <v-card
      v-if="openCheck()"
      :ref="randomId"
      light
      flat
      class="ma-0 primary--border"
      :class="{
        'lay-border': type === 'lay',
        'back-border': type === 'back'
      }"
      tile
    >
      <placebet-loader
        v-if="$store.state.placeBet && placeBetLoading"
        absolute
      ></placebet-loader>
      <v-form ref="betForm" v-model="valid" @submit.prevent="placeBet">
        <v-container class="pb-0">
          <v-list-item-title class="caption">
            {{ bettingMarket.event.name }}
            <div>
              {{ bettingRunner.name }}
              {{
                bettingMarket.mtype === 'MATCH_ODDS'
                  ? 'default'
                  : bettingMarket.mtype === 'MATCH_ODDS_SB'
                  ? 'bookmaker'
                  : 'fancy'
              }}
            </div>
          </v-list-item-title>
          <v-row align="center" justify="start" class="my-0">
            <v-col
              class="pb-0"
              :class="bettingType !== 'fancy' ? 'cols-4 pr-2' : 'cols-6'"
            >
              <!-- default text feild -->
              <v-text-field
                v-show="
                  bettingType !== 'fancy' &&
                  bettingType !== 'bookmaker' &&
                  bettingType !== 'threeEt' &&
                  bettingType !== 'multiHorse' &&
                  !sbOdds
                "
                v-model="compVal"
                prepend-inner-icon="mdi-minus"
                append-icon="mdi-plus"
                :label="bettingType === 'lineLadder' ? 'Runs' : 'Odds'"
                persistent-hint
                outlined
                dense
                :rules="oddsRules"
                class="caption"
                inputmode="numeric"
                @input="oddsInput"
                @blur="oddsBlur"
                @keypress="onlyNumber"
                @keydown.40="oddsStepper('down')"
                @keydown.38="oddsStepper('up')"
                @click:prepend-inner="oddsStepper('down')"
                @click:append="oddsStepper('up')"
              ></v-text-field>
              <!-- for SB -->
              <v-text-field
                v-show="sbOdds"
                v-model="compVal"
                :label="bettingType === 'lineLadder' ? 'Runs' : 'Odds'"
                persistent-hint
                readonly
                outlined
                dense
                :rules="oddsRules"
                class="caption"
                inputmode="numeric"
                @blur="oddsBlur"
              ></v-text-field>
              <!-- only for fancy -->
              <v-text-field
                v-show="bettingType === 'fancy'"
                v-model="fancyPrice"
                label="Odds"
                persistent-hint
                outlined
                dense
                class="caption"
                readonly
              ></v-text-field>
              <!-- only for bookmaker -->
              <v-text-field
                v-show="
                  bettingType === 'threeEt' ||
                  bettingType === 'bookmaker' ||
                  bettingType === 'multiHorse'
                "
                v-model="fancyPrice"
                label="Odds"
                persistent-hint
                outlined
                dense
                class="caption"
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              v-if="bettingMarket.mtype === 'INNINGS_RUNS'"
              class="pb-0"
              :class="bettingType !== 'fancy' ? 'cols-4 pl-0 pr-0' : 'cols-6'"
            >
              <v-text-field
                v-model="odds"
                label="Runs"
                persistent-hint
                outlined
                dense
                class="caption"
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              class="pb-0"
              :class="bettingType !== 'fancy' ? 'cols-4 pl-2' : 'cols-6'"
            >
              <v-text-field
                ref="stake"
                v-model="stake"
                label="Stake"
                :placeholder="`${placeholderMinMax}`"
                persistent-hint
                outlined
                dense
                :rules="stakeRules"
                class="caption"
                inputmode="numeric"
                @keydown.40="stakesAdd(-1)"
                @keydown.38="stakesAdd(1)"
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-2" no-gutters>
            <v-col>
              <span class="caption">or Choose You Stake Size</span>
            </v-col>
            <v-col class="text-right">
              <v-btn x-small to="/settings" color="primary" text class="caption"
                >Edit Stakes</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="userConfig" align="center" justify="center" no-gutters>
            <v-col
              v-for="(mobileStake, index) in userConfig"
              :key="index"
              cols="4"
              class="px-1 my-1"
            >
              <v-btn
                color="primary"
                block
                depressed
                small
                tile
                @click="stakesAdd(mobileStake)"
                >+{{ mobileStake | currencyFormat(0) }}</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="mt-2 mb-0" align="center" justify="center" no-gutters>
            <v-col cols="6" class="px-1">
              <v-btn
                color="grey darken-3"
                block
                outlined
                tile
                :disabled="loading"
                @click="cancelBtn()"
                >Cancel</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                class="multiline-btn place-bet-btn"
                :loading="placeBetLoading"
                block
                depressed
                tile
                color="primary"
                type="submit"
                :disabled="!valid"
              >
                <span class="d-block text-center">Place Bet</span>
                <span
                  v-if="valid && winning > 0"
                  class="d-block text-center"
                  style="line-height: 100%; font-size: 10px !important"
                >
                  <span>{{ type === 'lay' ? 'Liability' : 'Profit' }}:</span>
                  <span v-if="bettingType === 'bookmaker'">
                    {{ winning | currencyFormat(2) }}
                  </span>
                  <span v-if="bettingType !== 'bookmaker'">
                    {{ winning | currencyFormat(0) }}
                  </span>
                  <span v-if="bettingType === 'lineLadder'">
                    <!-- {{ winning }} -->
                  </span>
                </span>
                <div
                  v-if="
                    valid &&
                    winning > 0 &&
                    bettingMarket &&
                    bettingMarket.betDelay >= 0
                  "
                  class="sec-text"
                >
                  <span v-if="bettingType !== 'fancy'">
                    {{
                      bettingMarket.betDelay === 0 ? 1 : bettingMarket.betDelay
                    }}s
                  </span>
                  <span v-if="bettingType === 'fancy'">
                    {{
                      bettingRunner.betDelay === 0 ? 1 : bettingRunner.betDelay
                    }}s
                  </span>
                </div>
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="!minMaxMarketLoading" class="caption primary--text mt-2">
            <v-icon class="info-icon" color="primary">mdi-information</v-icon>
            Min Bet:
            <span v-if="bettingType === 'lineLadder'">{{ lineSession }}</span>
            <span v-else>{{ minBet }}</span>
            <span v-if="maxBetShow">
              Max Bet:
              {{ maxBetAmt }}
            </span>
            <span v-if="maxMarketAmountShow && maxMarketAmount !== 0">
              Max Winning: {{ maxMarketAmount }}</span
            >
          </div>
          <v-skeleton-loader
            v-if="minMaxMarketLoading"
            type="list-item"
          ></v-skeleton-loader>

          <confirm-bet></confirm-bet>

          <confirm-betdialogue
            :side="type"
            :betting-type="bettingType"
            :runs="runs"
            :stake="stake"
            :winning="winning"
            :odds="odds"
            :sb-odds="sbOdds"
            @confirm="placeBet"
          ></confirm-betdialogue>
        </v-container>
      </v-form>
    </v-card>
  </v-expand-transition>
</template>
<script>
import { mapState } from 'vuex'
import multiply from 'lodash/multiply'
import subtract from 'lodash/subtract'
import round from 'lodash/round'
import cloneDeep from 'lodash/cloneDeep'
// import map from 'lodash/map'
import upperFirst from 'lodash/upperFirst'
import compact from 'lodash/compact'
import min from 'lodash/min'
import ConfirmBet from '@/components/ConfirmBet'
import PlacebetLoader from '@/components/PlacebetLoader'
import ConfirmBetdialogue from '@/components/ConfirmBetdialogue'

export default {
  components: { ConfirmBet, ConfirmBetdialogue, PlacebetLoader },
  props: {
    checkId: { type: [String, Number, Array], default: '', required: false }
  },
  data() {
    return {
      randomId: Date.now(),
      gameMode: 'SportsBook',
      lineSession: 2,
      valid: true,
      winning: 0,
      stake: 0,
      odds: 0,
      sbOdds: 0,
      position: 0,
      type: '',
      minBet: 1,
      maxBetShow: true,
      maxMarketAmountShow: true,
      placeBetLoading: false,
      maxMarketAmount: 0,
      minBetAmt: 1,
      maxBetAmt: 100,
      placeholderMinMax: '',
      maxLimitsType: '',
      oddsRules: [
        (v) => !!v || 'Odds is required',
        (v) => parseFloat(v) >= 1.01 || 'Min. 1.01'
      ],
      stakeRules: [
        (v) => !!v || 'Stake is required',
        (v) => parseInt(v) >= this.minBet || 'Min. ' + this.minBet,
        (v) => parseInt(v) <= this.maxBetAmt || 'Max. ' + this.maxBetAmt
      ]
    }
  },
  computed: {
    ...mapState({
      bettingMarket: (state) => state.placeBet.market,
      bettingRunner: (state) => state.placeBet.runner,
      bettingAllRunners: (state) => state.placeBet.allRunners,
      bettingType: (state) => state.placeBet.bettingType,
      runs: (state) => state.placeBet.runs,
      matchIds: (state) => state.placeBet.matchIds,
      threeETId: (state) => state.placeBet.threeETId,
      userConfig: (state) =>
        state.auth.user.settings.presetStakeSettings.settings ||
        state.settings.defaultStake,
      confirmBetStatus: (state) => state.settings.confirmBetStatus,
      cloneOdds: (state) => state.placeBet.odds,
      cloneType: (state) => state.placeBet.type,
      loading: (state) => state.placeBet.loading,
      minMaxMarketLoading: (state) => state.matchInside.minMaxMarketLoading,
      configLimits: (state) => state.matchInside.configlimits,
      minMaxMarket: (state) => state.matchInside.minMaxMarket,
      userBalanceData: (state) => state.userBalance.userBalanceData,
      eventName: (state) => state.placeBet.event.event.name,
      event: (state) => state.placeBet.event,
      data: (state) => state.sportsbook.data,
      oneEventData: (state) => state.matchInside.dataDetails
    }),
    compVal: {
      get() {
        if (this.sbOdds) {
          return this.sbOdds
        } else {
          return this.odds
        }
      }
    }
  },
  watch: {
    cloneOdds() {
      this.initiatePopover()
    },
    cloneType() {
      this.initiatePopover()
    },
    odds() {
      this.calculateWinnings()
    },
    stake() {
      this.calculateWinnings()
    },
    configLimits() {
      this.setFancyLimit(100000000000000000000)
    },
    data() {
      // console.log('bettingMarket', this.bettingMarket)
      const type = this.$store.state.placeBet.odds.type
      const index = this.$store.state.placeBet.odds.index
      const eventId = this.$store.state.placeBet.event.id
      const clickedEvent = this.data[0]?.fixtures?.filter(
        (item) => item?.id === eventId
      )[0]
      const newIndex = (index) => {
        if (type === 'back') {
          if (
            clickedEvent?.runners
              ?.filter((item) => item?.id === this?.bettingRunner?.id)
              .map((item) => item[type])[0].length === 1
          ) {
            return [2, 1, 0][index]
          } else {
            return [0, 1, 2][index]
          }
        } else {
          return [0, 1, 2][index]
        }
      }

      // console.log('clickedEvent', clickedEvent)

      const newPrice = clickedEvent?.runners?.filter(
        (item) => item?.id === this?.bettingRunner?.id
      )[0][type][newIndex(index)]?.price

      if (clickedEvent?.mtype !== 'MATCH_ODDS') {
        this.odds = newPrice
      }
    }
  },
  async created() {
    if (this.$auth.loggedIn) {
      if (!this.userConfig) {
        await this.$store.dispatch('settings/getUserConfig')
      }
    }
    await this.initiatePopover()
    // console.log('this.oneEventData', this.oneEventData)
  },
  methods: {
    async initiatePopover() {
      this.odds = cloneDeep(this.$store.state.placeBet.odds).price
      this.fancyPrice = cloneDeep(this.$store.state.placeBet.odds).fancyPrice
      this.sbOdds =
        this.bettingMarket && this.bettingMarket?.id?.includes('SB')
          ? parseFloat(((this.odds - 1) * 100).toFixed(2) * 1)
          : 0
      this.position = this.$store.state.placeBet.oddsIndex
      this.type = cloneDeep(this.$store.state.placeBet.odds).type
      if (this.$auth.loggedIn) {
        if (
          this.bettingType === 'bookmaker' ||
          this.bettingType === 'multiHorse' ||
          this.bettingType === 'lineLadder' ||
          this.bettingType === 'fancy'
        ) {
          this.oddsRules = [
            (v) => !!v || 'Odds is required',
            (v) => parseFloat(v) >= 0 || 'Min. 0.1'
          ]
        }
        let minid = this.event.id

        if (this.bettingType === 'fancy') {
          minid = `${this.bettingMarket.id}`
        }
        let minMaxData = {
          game: upperFirst(this.eventName || 'Cricket'),
          loading: true,
          marketId: minid,
          runnerId: this.bettingRunner.id
        }
        if (this.bettingType === 'threeEt' && this.threeETId) {
          minMaxData.threeETId = this.threeETId
        } else if (this.bettingType === 'bookmaker') {
          minMaxData = {
            game: upperFirst(this.eventName || 'Cricket'),
            loading: true,
            oddsSelected: this.odds,
            position: this.position,
            selectionId: this.bettingRunner.id,
            type: this.type,
            marketId: minid,
            runnerId: `${this.bettingRunner.id}`
          }
        } else if (this.bettingType === 'lineLadder') {
          minMaxData = {
            game: upperFirst(this.eventName || 'Cricket'),
            loading: true,
            oddsSelected: this.odds,
            position: this.position,
            selectionId: this.bettingRunner.id,
            type: this.type,
            bettingType: this.bettingType,
            marketId: minid,
            runnerId: `${this.bettingRunner.id}`
          }
        }
        await this.$store.dispatch('matchInside/getMinMaxMarket', minMaxData)

        const maxAmtUnlimited = 1000000000000000
        if (this.bettingMarket) {
          if (this.minMaxMarket.minBet === 0 || !this.minMaxMarket.minBet) {
            this.minBet = 1
          } else {
            this.minBet = this.minMaxMarket.minBet
          }

          if (
            this.minMaxMarket.maxWinning &&
            this.minMaxMarket.maxWinning === 0
          ) {
            this.maxMarketAmount = maxAmtUnlimited
            this.maxMarketAmountShow = false
          } else {
            this.maxMarketAmount = this.minMaxMarket.maxWinPerMarket
          }
          if (
            !this.minMaxMarket.maxBet ||
            (this.minMaxMarket &&
              this.minMaxMarket.maxBet &&
              this.minMaxMarket.maxBet === 0)
          ) {
            this.maxBetShow = false
            this.maxBetAmt = maxAmtUnlimited
            this.placeholderMinMax = 'Min. ' + this.minBet
          } else {
            this.maxBetShow = true
            this.maxBetAmt = this.minMaxMarket.maxBet
            this.placeholderMinMax =
              'Min. ' + this.minBet + ' Max. ' + this.maxBetAmt
          }
        }
      }
      setTimeout(() => {
        if (this.$breakpoint.xsOnly && this.$refs[this.randomId]) {
          this.$vuetify.goTo(this.$refs[this.randomId], {
            duration: 100,
            easing: 'easeInOutCubic',
            offset: 100
          })
        }
        if (this.$refs.stake) {
          this.$nextTick(this.$refs.stake.focus)
        }
      }, 100)
    },
    cancelBtn() {
      this.$store.commit('placeBet/reset_popover')
      this.$store.commit('betBooks/reset_newData')
      this.stake = 0
    },
    stakesAdd(value) {
      this.$nextTick(this.$refs.stake.focus)
      this.$refs.stake.$el.focus()
      if (isNaN(parseFloat(this.stake))) {
        this.stake = 0
      }
      this.stake = parseFloat(this.stake) + parseFloat(value)
    },
    oddsStepper(event) {
      if (this.bettingType === 'lineLadder') {
        if (event === 'up') {
          this.odds = this.odds + 1
        } else if (event === 'down') {
          this.odds = this.odds - 1
        }
      } else {
        this.odds = this.incOrDec(this.odds, event)
      }
    },
    calculateWinnings() {
      if (this.stake > 0 && this.odds > 0) {
        let odds = this.odds
        if (this.bettingType === 'lineLadder') {
          odds = this.lineSession
        }
        if (
          this.bettingType === 'bookmaker' ||
          this.bettingType === 'fancy' ||
          this.bettingType === 'multiHorse'
        ) {
          if (this.bettingType !== 'fancy') {
            if (this.bettingMarket.placeBetCalcType === 2) {
              odds = odds + 1
            } else {
              odds = odds / 100 + 1
            }
          } else {
            odds = this.fancyPrice
          }
        }
        const m = multiply(parseFloat(odds), parseFloat(this.stake))
        const s =
          this.bettingType === 'fancy'
            ? m / 100
            : subtract(m, parseFloat(this.stake))
        this.winning = round(s, 2)
        if (
          this.bettingType === 'default' ||
          this.bettingType === 'lottery' ||
          this.bettingType === 'threeEt' ||
          this.bettingType === 'bookmaker'
        ) {
          this.newBook(this.winning)
        }
      }
    },
    newBook(winning) {
      let stake
      if (this.type === 'back') {
        stake = -parseFloat(this.stake)
      } else {
        winning = -winning
        stake = parseFloat(this.stake)
      }
      const pnlStatus = {}
      this.bettingAllRunners &&
        this.bettingAllRunners.forEach((r) => {
          if (r.id === this.bettingRunner.id) {
            pnlStatus[`${this.event.id}-${r.id}`] = {
              marketId: this.event.id,
              pnl: winning
            }
          } else {
            pnlStatus[`${this.event.id}-${r.id}`] = {
              marketId: this.event.id,
              pnl: stake
            }
          }
        })

      // const output = [
      //   {
      //     marketId: this.bettingMarket.id,
      //     horse
      //   }
      // ]
      // const newPnl = {
      //   marketId: this.bettingMarket.id,
      //   pnl
      // }
      setTimeout(() => {
        if (this.$refs.betForm && this.$refs.betForm.validate()) {
          // this.$store.commit('betBooks/set_newData', output)
          this.$store.commit('betBooks/set_newData', pnlStatus)
        } else {
          this.$store.commit('betBooks/reset_newData', pnlStatus)
        }
      }, 100)
    },
    async placeBet(status) {
      if (this.$refs.betForm && this.$refs.betForm.validate()) {
        this.placeBetLoading = true

        if (this.loading) {
          this.$store.commit('snackbar/open', {
            text: 'Please wait! Processing previous bet...',
            color: 'error'
          })
          return ''
        }
        if (this.confirmBetStatus && status !== 'betConfirmed') {
          this.placeBetLoading = false
          this.$store.commit('confirmBet/open')
          return ''
        }
        try {
          let watingSeconds
          if (this.bettingType === 'fancy') {
            watingSeconds = this.bettingRunner.betDelay || 1
          } else if (this.bettingType === 'bookmaker') {
            watingSeconds = this.bettingMarket.betDelay
          } else if (this.bettingType === 'threeEt') {
            watingSeconds = 0
          } else if (this.bettingType === 'lineLadder') {
            watingSeconds = this.bettingMarket.betDelay
          } else {
            watingSeconds = this.bettingMarket.betDelay || 1
          }
          this.$store.dispatch('betLoading/begin', watingSeconds)

          await this.$store.dispatch('placeBet/execute', {
            event: this.event,
            market: this.bettingMarket,
            runner: this.bettingRunner,
            odds: this.odds,
            position: this.position,
            runs: this.runs,
            stake: this.stake,
            type: this.type,
            winning: this.winning,
            fancyPrice: this.fancyPrice
          })
          this.$store.dispatch('betLoading/close')
          if (this.$store.state.placeBet.error) {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.error,
              color: 'error'
            })
            if (this.$store.state.placeBet.error === 'Access Denied') {
              this.$store.dispatch('user/logout')
            }
          } else if (this.$store.state.placeBet.warning) {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.warning.message,
              color: 'warning'
            })
          } else if (
            this.$store.state.placeBet.success.status === 'UNMATCHED' &&
            this.bettingType !== 'threeEt' &&
            this.$store.state.placeBet.success.message
          ) {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.success.message,
              color: 'error'
            })
          } else if (
            this.$store.state.placeBet.success.status === 'UNMATCHED' &&
            this.bettingType === 'threeEt' &&
            this.$store.state.placeBet.success.message
          ) {
            // console.error(this.$store.state.placeBet.success.message)
          } else if (
            this.$store.state.placeBet.success.status === 'UNMATCHED' &&
            this.bettingType !== 'lineLadder' &&
            this.$store.state.placeBet.success.message
          ) {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.success.message,
              color: 'error'
            })
          } else if (
            this.$store.state.placeBet.success.status === 'UNMATCHED' &&
            this.bettingType === 'lineLadder' &&
            this.$store.state.placeBet.success.message
          ) {
            // console.error(this.$store.state.placeBet.success.message)
          } else if (
            this.$store.state.placeBet.success &&
            this.$store.state.placeBet.success.status !== 'UNMATCHED' &&
            this.$store.state.placeBet.success.message
          ) {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.success.message,
              color: 'success'
            })
          } else if (this.$store.state.placeBet.blank) {
            // console.error(this.$store.state.placeBet.success.message)
          } else {
            this.$store.commit('snackbar/open', {
              text: this.$store.state.placeBet.success,
              color: 'success'
            })
          }
          this.placeBetLoading = this.loading
          this.cancelBtn()

          let betbooksCategory = 'betBooks/getAll'
          if (
            this.$route.name === 'sportsbook-category-id' ||
            this.$route.name === 'sportsbook-category-subCategory-id' ||
            this.$route.name ===
              'sportsbook-category-subCategory-id-betradar' ||
            this.$route.name === 'binary-id'
          ) {
            betbooksCategory = 'betBooks/get'
          }
          // console.log('bet popover', this.event)
          await Promise.all([
            this.$store.dispatch(
              betbooksCategory,
              this.event.event.id,
              this.refresh === false
            ),
            this.$store.dispatch('openBets/getMyCurrentBetStatus')
          ])
        } catch (error) {
          // console.log(error)
        }
      }
    },
    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 13) {
        $event.preventDefault()
      }
    },
    oddsBlur() {
      const value = this.odds
      if (value >= 1.01 && value < 2) {
        this.odds = this.incOrDecValidation(value, 0.01)
      } else if (value >= 2 && value < 3) {
        this.odds = this.incOrDecValidation(value, 0.02)
      } else if (value >= 3 && value < 4) {
        this.odds = this.incOrDecValidation(value, 0.05)
      } else if (value >= 4 && value < 6) {
        this.odds = this.incOrDecValidation(value, 0.1)
      } else if (value >= 6 && value < 10) {
        this.odds = this.incOrDecValidation(value, 0.2)
      } else if (value >= 10 && value < 20) {
        this.odds = this.incOrDecValidation(value, 0.5)
      } else if (value >= 20 && value < 30) {
        this.odds = this.incOrDecValidation(value, 1)
      } else if (value >= 30 && value < 50) {
        this.odds = this.incOrDecValidation(value, 2)
      } else if (value >= 50 && value < 100) {
        this.odds = this.incOrDecValidation(value, 5)
      } else if (value >= 100 && value < 1000) {
        this.odds = this.incOrDecValidation(value, 10)
      }
    },
    oddsInput(e) {
      this.odds = e
    },
    setFancyLimit(maxAmtUnlimited) {
      const { maxLimitsType = 'Minor' } = this.bettingRunner

      let maxRate = 1
      if (this.$auth.loggedIn && this.$auth.user.currencyType === 'POINT@1') {
        maxRate = 100
      }
      const maxBetFromLimit =
        this.configLimits['maxBetFancy' + maxLimitsType] / maxRate
      const maxMarketAmountFromLimit =
        this.configLimits['maxMarketAmountFancy' + maxLimitsType] / maxRate

      this.maxBetAmt = 0
      // MIN BET
      if (this.bettingMarket.minBet === 0) {
        this.minBet = 1
      } else {
        this.minBet = this.bettingMarket.minBet
      }

      // MAX BET
      if (this.bettingMarket.maxBetFancy === 0 && maxBetFromLimit === 0) {
        this.maxBetShow = false
        this.maxBetAmt = maxAmtUnlimited
        this.placeholderMinMax = 'Min ' + this.minBet
      } else {
        this.maxBetShow = true

        this.maxBetAmt = this.getMinimum(
          maxBetFromLimit,
          this.bettingMarket.maxBetFancy
        )
        this.placeholderMinMax =
          'Min. ' + this.minBet + ' Max. ' + this.maxBetAmt
      }

      // MAX MARKET
      if (
        this.bettingMarket.maxMarketAmountFancy === 0 &&
        maxMarketAmountFromLimit === 0
      ) {
        this.maxMarketAmount = maxAmtUnlimited
        this.maxMarketAmountShow = false
      } else {
        this.maxMarketAmount = this.getMinimum(
          maxMarketAmountFromLimit,
          this.bettingMarket.maxMarketAmountFancy
        )

        this.maxMarketAmountShow = true
      }
    },
    getMinimum(a, b) {
      let output = [a, b]
      output = compact(output)
      return min(output)
    },
    openCheck() {
      if (!this.$auth.loggedIn) {
        return false
      }
      if (
        this.$auth.loggedIn &&
        this.userConfig &&
        this.bettingType === 'default'
      ) {
        return true
      } else if (this.checkId === this.bettingRunner.id) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info-text {
  font-size: 10px;
  .info-icon {
    font-size: 13px;
  }
}
</style>
